export const getCurrentFrenchMonth = () => {
    const currentMonthName = new Date().toLocaleDateString('fr-FR', { month: 'long' });
    return currentMonthName.charAt(0).toUpperCase() + currentMonthName.slice(1);
}